export { default as parsePlaceholder } from './parsePlaceholder';
export { default as removeQuotesChar } from './removeQuotesChar';